import { z } from "zod";
import {
  SectionSpacingSchema,
  TextAlignSchema
} from "../../../../../zod/shared-schemas.mjs";
const FeatureSectionTextImageItemSchema = z.object({
  src: z.string(),
  alt: z.string().optional()
});
const FeatureSectionTextImageConfigSchema = z.object({
  src: z.string().optional(),
  alt: z.string().optional(),
  desktop: FeatureSectionTextImageItemSchema.optional(),
  tablet: FeatureSectionTextImageItemSchema.optional(),
  mobile: FeatureSectionTextImageItemSchema.optional()
});
const FeatureSectionTextImageSchema = z.object({
  id: z.string().optional(),
  title: z.string().optional(),
  description: z.string().optional(),
  image: FeatureSectionTextImageConfigSchema,
  button: z.object({
    title: z.string(),
    to: z.string(),
    color: z.string().optional(),
    align: TextAlignSchema.optional()
  }).optional(),
  textPosition: TextAlignSchema.optional()
}).merge(SectionSpacingSchema);
export default FeatureSectionTextImageSchema;
